import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Package } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  return (
    <div className="group bg-white rounded-2xl border border-slate-200 overflow-hidden card-lift" data-testid={`product-card-${product.product_id}`}>
      <Link to={`/product/${product.product_id}`}>
        <div className="aspect-[4/3] overflow-hidden bg-slate-100">
          <img src={product.image} alt={product.name}
               className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        </div>
      </Link>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-1">
          <Link to={`/product/${product.product_id}`}
                className="font-display font-bold text-slate-900 line-clamp-2 hover:text-indigo-600" data-testid={`product-name-${product.product_id}`}>
            {product.name}
          </Link>
          {product.featured && <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100 shrink-0">Featured</Badge>}
        </div>
        <p className="text-xs text-slate-500 mb-3 line-clamp-2">{product.description}</p>
        <div className="flex items-center gap-2 mb-3 text-xs">
          <Badge variant="outline" className="border-emerald-200 text-emerald-700 bg-emerald-50">
            <Package className="w-3 h-3 mr-1" /> Bulk from ${product.wholesale_price.toFixed(2)}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <div>
            <div className="text-lg font-extrabold font-display" data-testid={`product-price-${product.product_id}`}>${product.price.toFixed(2)}</div>
            <div className="text-[10px] text-slate-500">{product.stock} in stock</div>
          </div>
          <Button size="sm" className="rounded-full bg-indigo-600 hover:bg-indigo-700"
                  onClick={() => addItem(product, 1, false)}
                  data-testid={`product-add-to-cart-btn-${product.product_id}`}>
            <ShoppingCart className="w-4 h-4 mr-1" />Add
          </Button>
        </div>
      </div>
    </div>
  );
};
